export const assistantAsking = (question: string, answer?: string[] | string, numeric?: boolean, splitter: string = '') => {
    return answer ? [
        {role: "assistant", content: [{text: question}]},
        {
            role: "user",
            content: [{text: Array.isArray(answer) ? answer.map((item, index) => `${numeric == true ? `${index + 1}. ` : numeric == false ? "- " : ''}${item}`).join('\n' + splitter) : answer}]
        },
    ] : []
}

export const assistantAskingForInstructions = (answer?: string[]) => {
    return assistantAsking("Укажи инструкции как достичь результата", answer, true)
}

export const assistantAskingForRequirements = (answer?: string[]) => {
    return assistantAsking("Перечисли требования к результату", answer, false)
}

export const assistantAskingForSchema = (answer?: string) => {
    return assistantAsking("Опиши схему, которой должен соответствовать результат", answer)
}

export const assistantAskingForExample = (answer?: object) => {
    return assistantAsking("Приведи пример результата", JSON.stringify(answer))
}

export const assistantAskingForGenre = (answer?: string[] | string) => {
    return assistantAsking("Какой жанр произведения?", answer)
}

export const assistantAskingForSynopsis = (answer?: string) => {
    return assistantAsking("Опиши кратко сюжет (синопсис) произведения", answer)
}

export const assistantAskingForContext = (answer?: string[]) => {
    return assistantAsking("Укажи контекст", answer, undefined, '\n')
}

export const assistantAskingForAction = (answer?: string) => {
    return assistantAsking("Что нужно сделать?", answer)
}

export const systemInstruction = (instruction: string) => {
    return [{role: "system", content: [{text: instruction}]}]
}

export const userSaying = (text: string) => {
    return [{role: "user", content: [{text: text}]}]
}

export const userAsking = (question: string, answer?: string) => {
    return answer ? [
        {role: "user", content: [{text: question}]},
        {role: "assistant", content: [{text: answer}]},
    ] : []
}